import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { LoggerService, tryNormalizeHttpError, SiteConnector } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import {
  bufferCount,
  catchError,
  exhaustMap,
  filter,
  map,
} from 'rxjs/operators';
import { SiteContextActions } from '../actions';
import { getActiveCountry } from '../selectors/country.selectors';
import { StateWithSiteContext } from '../state';

@Injectable()
export class CountryEffects {
  protected logger = inject(LoggerService);

  loadCountry$: Observable<
    | SiteContextActions.LoadCountrySuccess
    | SiteContextActions.LoadCountryFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(SiteContextActions.LOAD_LANGUAGES),
      exhaustMap(() => {
        return this.siteConnector.getCountries().pipe(
          map(
            (countries) =>
              new SiteContextActions.LoadCountrySuccess(countries)
          ),
          catchError((error) =>
            of(
              new SiteContextActions.LoadCountryFail(
                tryNormalizeHttpError(error, this.logger)
              )
            )
          )
        );
      })
    )
  );

  activateCountry$: Observable<SiteContextActions.CountryChange> =
    createEffect(() =>
      this.state.select(getActiveCountry).pipe(
        bufferCount(2, 1),
        // avoid dispatching `change` action when we're just setting the initial value:
        filter(([previous]) => !!previous),
        map(
          ([previous, current]) =>
            new SiteContextActions.CountryChange({ previous, current })
        )
      )
    );

  constructor(
    private actions$: Actions,
    private siteConnector: SiteConnector,
    private state: Store<StateWithSiteContext>
  ) {}
}
